import React, { useState, useEffect, useContext, useRef } from 'react';
import Button from '../../components/button/button';
import { noHeaderContext, programmeContext, languageContext } from '../../contexts';

const isFullscreenSupported = () => {
    const el = document.documentElement;
    return !!(
        document.fullscreenEnabled ||
        document.webkitFullscreenEnabled ||
        el.requestFullscreen ||
        el.webkitRequestFullscreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullscreen
    );
};

const FullScreen = () => {
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [fullscreenAvailable, setFullscreenAvailable] = useState(false);
    const noHeader = useContext(noHeaderContext);
    const lang = useContext(languageContext);

    const isTransitioning = useRef(false);

    useEffect(() => {
        setFullscreenAvailable(isFullscreenSupported());

        const onFullScreenChange = () => {
            const fsElement =
                document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullscreenElement;

            setIsFullScreen(!!fsElement);
            isTransitioning.current = false;
        };

        document.addEventListener('fullscreenchange', onFullScreenChange);
        document.addEventListener('webkitfullscreenchange', onFullScreenChange);
        document.addEventListener('mozfullscreenchange', onFullScreenChange);
        document.addEventListener('MSFullscreenChange', onFullScreenChange);

        return () => {
            document.removeEventListener('fullscreenchange', onFullScreenChange);
            document.removeEventListener('webkitfullscreenchange', onFullScreenChange);
            document.removeEventListener('mozfullscreenchange', onFullScreenChange);
            document.removeEventListener('MSFullscreenChange', onFullScreenChange);
        };
    }, []);

    const toggleFullScreen = () => {
        if (isTransitioning.current) return;
        isTransitioning.current = true;

        const domElement = document.getElementById('moteur-v6');
        if (!domElement) {
            isTransitioning.current = false;
            return;
        }

        if (!isFullScreen) {
            if (domElement.requestFullscreen) {
                domElement.requestFullscreen();
            } else if (domElement.webkitRequestFullscreen) {
                domElement.webkitRequestFullscreen();
            } else if (domElement.mozRequestFullScreen) {
                domElement.mozRequestFullScreen();
            } else if (domElement.msRequestFullscreen) {
                domElement.msRequestFullscreen();
            } else {
                isTransitioning.current = false;
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            } else {
                isTransitioning.current = false;
            }
        }
    };

    if (!fullscreenAvailable) return null;

    return (
        <programmeContext.Consumer>
            {datas => (
                datas != null && (
                    <div id="fullScreen" className={noHeader ? 'noHeader' : ''}>
                        <Button
                            icon="fullscreen"
                            text={datas.languagesDatas[lang].header.fullscreen.fullscreen}
                            state={isFullScreen}
                            action={toggleFullScreen}
                            displayText={datas.displayText}
                        />
                    </div>
                )
            )}
        </programmeContext.Consumer>
    );
};

export default FullScreen;
